import React from "react";
import { MENSAJE_SOLO_LECTURA } from "../utilities/permisos";

// Aviso visible (no depende de pasar el mouse) para el Administrador en las pantallas
// donde los botones de cobrar y validar aparecen deshabilitados.
const AvisoSoloLectura = ({ visible }) => {
  if (!visible) return null;
  return (
    <p className="aviso-solo-lectura" role="note">
      🔒 {MENSAJE_SOLO_LECTURA}
    </p>
  );
};

export default AvisoSoloLectura;
